import React from 'react';
import { useTranslation } from 'react-i18next';
import { EMAIL_TEMPLATE_PLACEHOLDER_LABEL_KEYS } from './emailTemplatePlaceholderDefinitions';
import './_styles_/EmailTemplatePlaceholders.css';

function EmailTemplatePlaceholders() {
    const { t } = useTranslation();
    return (
        <div className="email-template-placeholders">
            <span className="email-template-placeholders--title">
                {t('email-templates.available-placeholders')}
            </span>
            <table className="email-template-placeholders--list">
                <tbody>
                    {Object.entries(EMAIL_TEMPLATE_PLACEHOLDER_LABEL_KEYS).map(([token, labelKey]) => (
                        <tr key={token} className="email-template-placeholders--item">
                            <td className="email-template-placeholders--token-cell">
                                <code className="email-template-placeholders--token">{token}</code>
                            </td>
                            <td className="email-template-placeholders--description">{t(labelKey)}</td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );
}

export default EmailTemplatePlaceholders;
